import useEditorQuery from "../../../hooks/useEditorQuery";
import orderClient from "../../../api/order";

const useOrderQuery = (orderName: string) => {
  return useEditorQuery({
    queryKey: ["order", orderName],
    queryFn: async () => orderClient.getOrderInfo(orderName),
    enabled: !!orderName,
  });
};
export default useOrderQuery;
